#import "../../../../../core-entity/graphql/fragments/tag-fragment.graphql"

fragment AccountInfoFragment on Account {
    id
    name
    description
    territory {
        id
    }
    employeeCount
    revenue {
        currencyValue {
            amount
        }
    }
    owner {
        id
    }
    industry {
        id
    }
    accountType {
        id
    }
    tags {
        ...TagFragment
    }
    tagMaps(first: 1000) {
        totalCount
        edges {
            creator {
                id
                name
            }
            createdTime
            node {
                ...TagFragment
            }
        }
    }
}
